import { render, staticRenderFns } from "./DaySelectMenuForm.vue?vue&type=template&id=0ca249c6&"
import script from "./DaySelectMenuForm.vue?vue&type=script&lang=js&"
export * from "./DaySelectMenuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports